var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header-wrapper',[_c('div',{staticClass:"erp-list-page baidao-list-page delivery-line-page"},[_c('basic-option-table',{attrs:{"item":_vm.item}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }